import { fabric } from 'fabric-with-erasing'

fabric.BaseFiveWithOpacity = fabric.util.createClass(fabric.BaseBrush, {
  color: '#fff',
  opacity: 1,
  width: 2,
  canvas: null,
  currentWidth: 0.5,
  currentPoint: null,
  lastPoint: null,
  sime: 0,
  group: null,
  temporaryPoints: [],
  addOfInstance: 0,
  currentOpacity: 0.1,

  initialize: function (canvas, options) {
    this.currentPoint = null
    this.lastPoint = null
    this.currentWidth = 0.5
    this.temporaryPoints = []
    this.addOfInstanceWidth = (this.width - this.currentWidth) / 5 // 增加幅度，每次增加多少宽度
    this.addOfInstanceOpacity = (1 - this.currentOpacity) / 5 // 增加幅度，每次增加多少透明度

    this.canvas = canvas
    this.callSuper('initialize', canvas, options)
  },

  onMouseDown: function (point) {
    this.currentPoint = { x: point.x, y: point.y }
    this.lastPoint = { x: point.x, y: point.y }

    this.group = new fabric.Group([])
    this.canvas.add(this.group)
    this.addPathSegment([{ x: point.x, y: point.y }])
  },

  onMouseMove: function (point) {
    if (!this.lastPoint) return

    this.temporaryPoints.push({ x: point.x, y: point.y })

    if (this.temporaryPoints.length >= 2) {
      this.currentPoint = { x: point.x, y: point.y }
      this.currentWidth = Math.min(this.currentWidth + this.addOfInstanceWidth, this.width)
      this.currentOpacity = Math.min(this.currentOpacity + this.addOfInstanceOpacity / 2, 1)
      this.addPathSegment([
        { x: this.lastPoint.x, y: this.lastPoint.y },
        ...this.temporaryPoints
      ])

      this.lastPoint = point
      this.temporaryPoints = []
    }
  },

  onMouseUp: function () {
    this.currentPoint = null
    this.lastPoint = null
    this.currentWidth = 0.5
    this.temporaryPoints = []
    this.currentOpacity = 0.1
  },

  addPathSegment: function (points) {
    const pathString = this.convertPointsToSVGPath(points)
    const newPath = new fabric.Path(pathString, {
      stroke: this.color,
      strokeWidth: this.currentWidth,
      fill: '',
      selectable: false,
      evented: false,
      opacity: this.currentOpacity,
      strokeLineCap: this.currentOpacity === 1 ? 'round' : '' // 确保端点和连接处是圆角
    })

    this.group.addWithUpdate(newPath)
    this.canvas.requestRenderAll()
  },

  convertPointsToSVGPath: function (points) {
    if (points.length < 2) return ''

    let path = `M ${points[0].x} ${points[0].y}`

    for (let i = 1; i < points.length; i++) {
      const startPoint = points[i - 1]
      const endPoint = points[i]
      const midPoint = {
        x: (startPoint.x + endPoint.x) / 2,
        y: (startPoint.y + endPoint.y) / 2
      }
      path += ` Q ${midPoint.x} ${midPoint.y} ${endPoint.x} ${endPoint.y}`
    }

    return path
  }
})
